import { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import CrudPage from "@/components/CrudPage";
import { SpecialtyTree } from "@/components/SpecialtyTree";
import { doctorsConfig } from "@/pages/spConfigs";

export default function DoctorsPage() {
  const api = useApi();
  const [tree, setTree] = useState([]);
  const [sel, setSel] = useState({});
  const loadTree = useCallback(() => api("get", "/specialties").then(setTree).catch((e) => toast.error(errMsg(e))), [api]);
  useEffect(() => { loadTree(); }, [loadTree]);

  const config = useMemo(() => {
    const options = tree.flatMap((c) => c.subs.map((s) => ({ value: s.name, label: c.name === "Autres / non classés" ? `Autre — ${s.name}` : `${c.name} — ${s.name}` })));
    return {
      ...doctorsConfig,
      embedded: true,
      filter: sel.sub ? (i) => i.sub_category === sel.sub : sel.cat ? (i) => i.category === sel.cat : null,
      onChange: loadTree,
      fields: doctorsConfig.fields.map((f) => (f.key === "specialty" ? { ...f, type: "select", options } : f)),
    };
  }, [tree, sel, loadTree]);

  return (
    <div className="space-y-8" data-testid="doctors-page">
      <PageHeader title="Praticiens" subtitle="Tous les professionnels de santé de l'application, classés par catégorie et par spécialité." />
      <div className="grid lg:grid-cols-[300px_1fr] gap-6 items-start">
        <SpecialtyTree tree={tree} sel={sel} onSelect={setSel} />
        <div className="space-y-3 min-w-0">
          <p className="text-sm text-stone-600" data-testid="doctors-selection">{sel.sub ? `${sel.cat} › ${sel.sub}` : sel.cat || "Tous les praticiens"}</p>
          <CrudPage config={config} />
        </div>
      </div>
    </div>
  );
}
